'use strict';

class videoPlayer {

    constructor() {

        const $ = require('jquery');

        let $iframes = $('.ce-text-with-media iframe');
        let playerVimeo;
        let playerYoutube;

        if ($iframes.length > 0) {

            $iframes.each(function () {

                let playerIsVimeo = false;
                let $this = $(this);
                let $playControl = $this.siblings('[data-control-play]');

                if ($this.get(0).src.indexOf('vimeo') !== -1)  {

                    const Vimeo = require('./../../../../build/node_modules/@components/vimeo/dist/player.js');

                    playerVimeo = new Vimeo($this);
                    playerIsVimeo = true;
                } else {

                    let tag = document.createElement('script');

                    tag.id = 'iframe-demo';
                    tag.src = 'https://www.youtube.com/iframe_api';

                    let firstScriptTag = document.getElementsByTagName('script')[0];

                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                    App.Globals.window.onYouTubeIframeAPIReady = function () {

                        playerYoutube = new YT.Player('youtube-video');
                    };
                }

                $playControl.on('click', function () {

                    if ( playerIsVimeo ) {
                        playerVimeo.play();
                    } else {
                        playerYoutube.playVideo();
                    }
                    $this
                        .closest('.media-container')
                        .addClass('is-playing');
                });

                $playControl.on('keyup', function(event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        $playControl.click();
                    }
                });
            });
        }
    }
}

module.exports = videoPlayer;
